import {Component} from '@angular/core';
import {SuperClass} from '../../../superclass/SuperClass';
import {RouterConst} from '../../../globals/RoutersConst';
import {HttpClient} from '@angular/common/http';
import {DashboardDataService} from '../../../services/dashboard-data.service';
import {CookieService} from 'ngx-cookie-service';
import {BreadcrumbService} from '../../../breadcrumb.service';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ClientsService} from '../../../services/clients/clients.service';
import {WsService} from '../../../services/websocket/WsService';
import {Region} from './region.model';

@Component({
  selector: 'app-regions',
  templateUrl: './regions.component.html',
  styleUrls: ['./regions.component.css']
})
export class RegionsComponent extends SuperClass {

  display: boolean;
  newRegion: Region;
  selectedRow: Region;

  selectedRowForm: FormGroup;
  newRegionForm: FormGroup;

  regions: Region[];

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Email Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_EMAIL_ACCOUNTS] } },
        ],
      },
    ]);
    this.newRegion = new Region();
  }


  selectRow(e) {
    this.selectedRow = new Region(e.data);
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  reloadData(): void {
    this.http_getAllRegions((response: any) => {
      this.regions = response.payload;
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      automaticForgottenFromLastVisit: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(730),
          Validators.min(0)
        ])
      ),
      automaticForgottenFromFirstVisit: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(730),
          Validators.min(0)
        ])
      )
    });

    this.newRegionForm = this.fb.group({
      name: new FormControl('', Validators.required),
      automaticForgottenFromLastVisit: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(730),
          Validators.min(0)
        ])
      ),
      automaticForgottenFromFirstVisit: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(730),
          Validators.min(0)
        ])
      )
    });
  }

  addNewRegion() {
    this.display = true;
    this.newRegion = new Region();
  }

  createNewRegion() {
    this.http_createRegion(this.newRegion, (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.regions = data.payload;
      this.unselectRow();
    });
    this.display = false;
  }

  saveRegion() {
    this.http_updateRegion(this.selectedRow, (data: any) => {
      this.showSuccessMessage('Region has been deleted');
      this.regions = data.payload;
      this.unselectRow();
    });
  }

  deleteRegion() {
    this.http_deleteRegion(this.selectedRow, (data: any) => {
      this.showSuccessMessage('Region has been deleted');
      this.regions = data.payload;
      this.unselectRow();
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/regions/regions.component.ts